import { VdsSidenavItem } from '@volt/volt-extended-components-react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavLinkData } from '@casops/navigation';
import { ReactElement } from 'react';

interface SideNavLinkProps {
  isOpen: boolean;
  linkData: NavLinkData;
}

export const SideNavLink = ({
  isOpen,
  linkData: { to, titleKey, icon, useTitle },
}: SideNavLinkProps): ReactElement => {
  const { t } = useTranslation();

  // Use the optional hook to get a dynamic title or default to translating the static translation key.
  const title = useTitle?.() || t(titleKey);

  return (
    <NavLink
      to={to}
      style={{ textDecoration: 'none' }}
      title={!isOpen ? title : undefined} // Add a browser title attribute when the side nav is collapsed.
    >
      {({ isActive }) => (
        <VdsSidenavItem
          icon={icon}
          expanded={isOpen}
          value={title}
          isActive={isActive}
          hasChildren={true}
        />
      )}
    </NavLink>
  );
};

export default SideNavLink;
